export const default_donut_data = {
  labels: [],
  datasets: [
    {
      data: [],
      backgroundColor: [],
      borderWidth: 0,
      borderRadius: {
        outerEnd: 100,
        innerEnd: 100,
      },
      spacing: -130,
    },
  ],
};

export const default_linechart_data = {
  labels: [],
  datasets: [
    {
      data: [],
      type: "line",
      backgroundColor: "#5B93FF",
      borderColor: "#FFD66B",
      fill: false,
      borderWidth: 3,
      pointBackgroundColor: "#fff",
      pointBorderColor: "#AE8FF7",
      pointRadius: 4,
      pointBorderWidth: 3,
    },
  ],
};

export const default_bubblechart_data = {
  datasets: [
    {
      label: "",
      data: [
        { x: 100, y: 90, value: "Bibek Lama" },
        { x: 40, y: 10, value: "Mickael Saada" },
        { x: 30, y: 25, value: "Harry Melka" },
        { x: 15, y: 35, value: "Samantha Smith" },
        { x: 25, y: 20, value: "Jonathan Lee" },
        { x: 35, y: 15, value: "Emma Thompson" },
        { x: 45, y: 5, value: "Daniel Brown" },
        { x: 10, y: 40, value: "Sophia Garcia" },
        { x: 50, y: 30, value: "Liam Patel" },
        { x: 20, y: 5, value: "Olivia Nguyen" },
        { x: 30, y: 30, value: "Benjamin Kim" },
        { x: 40, y: 20, value: "Isabella Ali" },
        { x: 5, y: 25, value: "James Lopez" },
      ],
      backgroundColor: (context) => {
        // TODO : change to computed value

        if (context?.dataset?.data?.length <= 0) {
          return;
        }
        const { infos, x, y } = context.dataset.data[context.dataIndex];

        const isAnonymized = infos?.name === "Anonymized";
        if (isAnonymized) {
          return "rgba(200, 200, 200, 1)"; // Grey color
        }

        if (x < 350 && y < 17) {
          return "rgba(234, 67, 53, 1)"; // Red color
        }
        if (x >= 380 && y >= 23) {
          return "rgba(5, 205, 153, 1)"; // Green color
        }
        return "rgba(251, 188, 5, 1)"; // Yellow color
      },
      // hoverBackgroundColor: "rgba(255, 99, 132, 0.8)", // Adjust the color as needed
    },
  ],
};
